export default { sha: '84c4f8df8c3abe3bd8813b87e05bb600b2ccd11c', buildNumber: 'undefined' }
